const AnnouncementBar = () => {
  return (
    <div className="bg-secondary py-2 px-4 border-b border-border overflow-hidden">
      <div className="container flex items-center justify-center">
        <p className="text-[10px] sm:text-sm text-muted-foreground text-center tracking-wide leading-relaxed">
          🛡️ Registro COFEPRIS: 2319035019X00144 | 🏥 Formulado con Ker Clinic | 🚚 Envío Gratis en todos los pedidos | ✓ Garantía 30 días
        </p>
      </div>
    </div>
  );
};

export default AnnouncementBar;
